/* LOLOWORLD — scripts propios (vanilla, sin librerías) */
(function () {
  'use strict';
  // Cada sección incluye este archivo: solo debe ejecutarse una vez.
  if (window.__mtCargado) return;
  window.__mtCargado = true;

  var observer = null;

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.top < 0) {
            e.target.classList.add('mt-visible');
            observer.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--mt-i')) {
        var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : i;
        el.style.setProperty('--mt-i', Math.min(sib, 6));
      }
      observer.observe(el);
    });
    // Red de seguridad: si algo falla, nada queda invisible
    setTimeout(function () {
      document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('mt-visible');
      });
    }, 2500);
  }

  /* ---------- Galería ---------- */
  function initGaleria(root) {
    var imgs = root.querySelectorAll('[data-mt-img]');
    var thumbs = root.querySelectorAll('[data-mt-thumb]');
    if (!imgs.length) return;
    var actual = 0;
    function ir(n) {
      actual = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, i) { im.classList.toggle('mt-activa', i === actual); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === actual ? 'true' : 'false'); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { ir(i); }); });
    var ant = root.querySelector('[data-mt-ant]');
    var sig = root.querySelector('[data-mt-sig]');
    if (ant) ant.addEventListener('click', function () { ir(actual - 1); });
    if (sig) sig.addEventListener('click', function () { ir(actual + 1); });
    var x0 = null, main = root.querySelector('.mt-gal__main');
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }
    ir(0);
  }

  /* ---------- Producto: variantes, cantidad ---------- */
  function initProducto(root) {
    var dataEl = root.querySelector('[data-mt-variantes]');
    var form = root.querySelector('form[data-mt-form]');
    if (!dataEl || !form) return;
    var variantes = [];
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var boton = form.querySelector('[data-mt-boton]');
    var etiqueta = boton ? boton.querySelector('[data-mt-boton-txt]') : null;
    var precio = root.querySelector('[data-mt-precio]');
    var antes = root.querySelector('[data-mt-antes]');
    var ahorro = root.querySelector('[data-mt-ahorro]');
    var formato = root.getAttribute('data-formato') || '{{amount}}';
    function separar(n, sep, dec, decimales) {
      var partes = n.toFixed(decimales).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return partes.join(dec);
    }
    var fmt = {
      format: function (n) {
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, tipo) {
          switch (tipo) {
            case 'amount_no_decimals': return separar(n, ',', '.', 0);
            case 'amount_with_comma_separator': return separar(n, '.', ',', 2);
            case 'amount_no_decimals_with_comma_separator': return separar(n, '.', ',', 0);
            case 'amount_with_apostrophe_separator': return separar(n, "'", '.', 2);
            case 'amount_no_decimals_with_space_separator': return separar(n, ' ', '.', 0);
            case 'amount_with_space_separator': return separar(n, ' ', ',', 2);
            default: return separar(n, ',', '.', 2);
          }
        });
      }
    };

    function seleccion() {
      return Array.prototype.map.call(root.querySelectorAll('.mt-opcion'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function nombresElegidos() {
      Array.prototype.forEach.call(root.querySelectorAll('.mt-opcion'), function (fs) {
        var c = fs.querySelector('input:checked');
        var s = fs.querySelector('[data-mt-elegida]');
        if (c && s) s.textContent = c.getAttribute('data-etiqueta') || c.value;
      });
    }
    function actualizar() {
      nombresElegidos();
      var sel = seleccion();
      var v = variantes.filter(function (x) {
        return x.options.every(function (o, i) { return o === sel[i]; });
      })[0];
      if (!v) {
        if (boton) { boton.disabled = true; if (etiqueta) etiqueta.textContent = root.getAttribute('data-txt-no'); }
        return;
      }
      idInput.value = v.id;
      if (precio) precio.textContent = fmt.format(v.price / 100);
      var hayOferta = v.compare && v.compare > v.price;
      if (antes) { antes.hidden = !hayOferta; if (hayOferta) antes.textContent = fmt.format(v.compare / 100); }
      if (ahorro) {
        ahorro.hidden = !hayOferta;
        if (hayOferta) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare) * 100) + '%';
      }
      if (boton) {
        boton.disabled = !v.available;
        if (etiqueta) etiqueta.textContent = v.available ? root.getAttribute('data-txt-comprar') : root.getAttribute('data-txt-agotado');
      }
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(null, '', u.toString());
      }
    }
    root.querySelectorAll('.mt-opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });

    var qty = root.querySelector('[data-mt-qty]');
    if (qty) {
      var inp = qty.querySelector('input');
      qty.querySelector('[data-mt-menos]').addEventListener('click', function () { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1); });
      qty.querySelector('[data-mt-mas]').addEventListener('click', function () { inp.value = Math.min(99, (parseInt(inp.value, 10) || 1) + 1); });
      inp.addEventListener('change', function () { inp.value = Math.min(99, Math.max(1, parseInt(inp.value, 10) || 1)); });
    }
    actualizar();
  }

  function initAll(scope) {
    var s = scope || document;
    initReveal(s);
    s.querySelectorAll('[data-mt-galeria]').forEach(initGaleria);
    s.querySelectorAll('[data-mt-producto]').forEach(initProducto);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
